import type { PersonRef } from "@scheduler/shared";
import { useEffect, useState } from "react";

import { useSchedulerApi } from "./api/scheduler";
import { setDevActor } from "./auth/identity";

/**
 * Local development only: shows who this tab is acting as and lets you switch.
 * Rendered only when auth/identity.ts reports a dev actor, which is never the
 * case in a production build.
 */
export function DevActorBar({ actor }: { actor: string }) {
  const api = useSchedulerApi();
  const [people, setPeople] = useState<PersonRef[]>([]);

  useEffect(() => {
    api.people().then(setPeople, () => setPeople([]));
  }, [api]);

  return (
    <label className="devbar" title="Development only — not a sign-in">
      <span className="tag">Dev</span>
      Acting as
      <select value={actor} onChange={(e) => setDevActor(e.target.value)}>
        {people.some((p) => p.id === actor) ? null : <option value={actor}>#{actor}</option>}
        {people.map((p) => (
          <option key={p.id} value={p.id}>{p.name} (#{p.id})</option>
        ))}
      </select>
    </label>
  );
}
